export default __webpack_public_path__ + "static/media/nft-10.a2eb5763.png";